
<template>
  <div><span>{{ display }}</span></div>
</template>

<script>
import { formatTemplate } from '../utils/handlebars'

export default {
  props: {
    message: {
      type: String,
      default: null
    },
    context: {
      type: Object,
      default: () => ({})
    }

  },
  computed: {
    display() {
      if (this.message && this.message.length) {
        return formatTemplate(this.message, this.context)
      }
      else {
        return '---no more---'
      }
    }

  }
}
</script>

<style scoped>

</style>
